module.exports = __webpack_public_path__ + "static/Schnyder-L-Light-679a583a8192ea4787057833d35f91d4.otf";